import * as types from '@/store/mutation-types';

const mutations = {
  [types.ADD_TEMPLATE](state, p) {
    p.site.templates.push(p.template);
  },
};

const actions = {
  addTemplate: ({ commit, rootState }, template) => {
    const p = {
      site: rootState.Websites.currentSite,
      template,
    };
    commit(types.ADD_TEMPLATE, p);
  },
};

export default {
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/global-view/editor/page/top-control-bar/add-template/vuex.js